import { Data } from '../../../database.schema';
import { useFetchData } from '../tournament-data';

const itinerary = {
  itemColours: {
    golf: '#bbd780',
    preDrinks: '#e99494',
    dinner: '#88c4dd',
    taxi: '#7b8897',
    miscellaneous: 'royalblue',
  },
  days: [
    {
      date: '2026-11-08',
      items: [
        { type: 'golf', icon: 'golf.png', heading: 'GOLF', timeCopy: '1st Tee Time', time: '12:00pm', content: ['Course: Quinta South', 'Players: Ibis 6', 'Comp: Team game'] },
        { type: 'taxi', icon: 'taxi.png', heading: 'TAXI', timeCopy: 'Time', time: '6:30pm', content: ['Pickup: Fairways', 'Destination: Vilamoura'] },
        { type: 'preDrinks', icon: 'drinks.png', heading: 'DRINKS', timeCopy: 'Time', time: '6:45pm', content: ['Venue: Vilamoura', 'Finger Night'] },
        { type: 'dinner', icon: 'dinner.png', heading: 'DINNER', timeCopy: 'Time', time: '8:30pm', content: ['Restaurant: The Whale'] },
        { type: 'taxi', icon: 'taxi.png', heading: 'TAXI', timeCopy: 'Time', time: '10:30pm', content: ['Pickup: Vilamoura', 'Destination: Fairways'] },
      ],
    },
    {
      date: '2026-11-09',
      items: [
        { type: 'taxi', icon: 'taxi.png', heading: 'TAXI', timeCopy: 'Time', time: '11:44pm', content: ['Pickup: Fairways', 'Destination: Laranjal'] },
        { type: 'golf', icon: 'golf.png', heading: 'GOLF', timeCopy: '1st Tee Time', time: '1:04pm', content: ['Course: Laranjal', 'Players: All', 'Comp: Ryder Cup'] },
        { type: 'taxi', icon: 'taxi.png', heading: 'TAXI', timeCopy: 'Time', time: '5:45pm', content: ['Pickup: Laranjal', 'Destination: Fairways'] },
        { type: 'preDrinks', icon: 'drinks.png', heading: 'DRINKS', timeCopy: 'Time', time: '6:45pm', content: ['Venue: Fairways'] },
        { type: 'taxi', icon: 'taxi.png', heading: 'TAXI', timeCopy: 'Time', time: '7:45pm', content: ['Pickup: Fairways', 'Destination: Yu Algavre'] },
        { type: 'dinner', icon: 'dinner.png', heading: 'DINNER', timeCopy: 'Time', time: '8:00pm', content: ['Restaurant: Yu Algarve'] },
        { type: 'taxi', icon: 'taxi.png', heading: 'TAXI', timeCopy: 'Time', time: '10:15pm', content: ['Pickup: Yu Algarve', 'Destination: Fairways'] },
      ],
    },
    {
      date: '2026-10-29',
      items: [
        { type: 'golf', icon: 'golf.png', heading: 'GOLF', timeCopy: '1st Tee Time', time: '1:04pm', content: ['Course: Quinta North', 'Players: All', 'Comp: Ryder Cup'] },
        { type: 'taxi', icon: 'taxi.png', heading: 'TAXI', timeCopy: 'Time', time: '6:30pm', content: ['Pickup: Fairways', 'Destination: Cheeky Pup'] },
        { type: 'preDrinks', icon: 'drinks.png', heading: 'DRINKS', timeCopy: 'Time', time: '6:45pm', content: ['Venue: Cheeky Pup'] },
        { type: 'taxi', icon: 'taxi.png', heading: 'TAXI', timeCopy: 'Time', time: '8:15pm', content: ['Pickup: Cheeky Pup', 'Destination: Bold Octopus'] },
        { type: 'dinner', icon: 'dinner.png', heading: 'DINNER', timeCopy: 'Time', time: '8:30pm', content: ['Restaurant: Bold Octopus'] },
        { type: 'taxi', icon: 'taxi.png', heading: 'TAXI', timeCopy: 'Time', time: '10:30pm', content: ['Pickup: Bold Octopus', 'Destination: Fairways'] },
      ],
    },
    {
      date: '2026-10-30',
      items: [
        { type: 'golf', icon: 'golf.png', heading: 'GOLF', timeCopy: 'Tee Time', time: '1:04pm', content: ['Course: Quinta South', 'Players: Plough, BW & Woof', 'Comp: n/a'] },
        { type: 'golf', icon: 'golf.png', heading: 'GOLF', timeCopy: 'Tee Time', time: 'tbc', content: ['Course: Quinta do Vale', 'Players: Nige & Bushy'] },
        { type: 'miscellaneous', icon: 'beach.png', heading: 'BEACH WALK / LUNCH', timeCopy: 'Time', time: 'tbc', content: ['Players: Burt, Uggsy & Rock'] },
        { type: 'taxi', icon: 'taxi.png', heading: 'TAXI', timeCopy: 'Time', time: '6:30pm', content: ['Pickup: Fairways', 'Destination: Loule'] },
        { type: 'preDrinks', icon: 'drinks.png', heading: 'DRINKS', timeCopy: 'Time', time: '6:45pm', content: ['Venue: Loule'] },
        { type: 'dinner', icon: 'dinner.png', heading: 'DINNER', timeCopy: 'Time', time: '8:30pm', content: ['Restaurant: 11 da Villa'] },
        { type: 'taxi', icon: 'taxi.png', heading: 'TAXI', timeCopy: 'Time', time: '10:30pm', content: ['Pickup: 11 da Villa', 'Destination: Fairways'] },
      ],
    },
    {
      date: '2026-10-31',
      items: [
        { type: 'golf', icon: 'golf.png', heading: 'GOLF', timeCopy: '1st Tee Time', time: '1:04pm', content: ['Course: Quinta South', 'Players: All', 'Comp: Ryder Cup'] },
        { type: 'miscellaneous', icon: 'prizes.png', heading: 'PRIZE GIVING', timeCopy: 'Time', time: 'asap', content: ['Venue: Quinta Clubhouse', 'Players: All'] },
        { type: 'preDrinks', icon: 'drinks.png', heading: 'DRINKS', timeCopy: 'Time', time: '6:30pm', content: ['Venue: Fairways'] },
        { type: 'taxi', icon: 'taxi.png', heading: 'TAXI', timeCopy: 'Time', time: '7:45pm', content: ['Pickup: Fairways', 'Destination: Malveiro'] },
        { type: 'dinner', icon: 'dinner.png', heading: 'DINNER', timeCopy: 'Time', time: '8:00pm', content: ['Restaurant: Malveiro'] },
        {
          type: 'miscellaneous',
          icon: 'champagne.png',
          heading: 'REVIEW',
          timeCopy: 'Time',
          time: 'tbc',
          content: ['Champagne moments,', 'on and off the course'],
        },
        { type: 'taxi', icon: 'taxi.png', heading: 'TAXI', timeCopy: 'Time', time: '10:10pm', content: ['Pickup: Malveiro', 'Destination: Fairways'] },
      ],
    },
    {
      date: '2026-11-01',
      items: [{ type: 'miscellaneous', icon: 'plane.png', heading: 'GO HOME', timeCopy: 'Time', time: 'n/a', content: ['Time to bugger off home!!'] }],
    },
  ],
};
export const useFetchItinerary = (selectedIndex: number) => {
  return useFetchData((data: Data) => {
    const tournament = data.tournaments[selectedIndex];
    if (tournament && tournament.itinerary) {
      console.log('<><><><><');
      return tournament.itinerary;
    }
    console.log('<><><><><');
    return itinerary;
    // return data.courses;
  });
};
